import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const GET_MOLECULAR_WEIGHT_QUERY = gql`
  query GetMolecularWeightQuery($moleculeIds: [StrictString!]!) @skipAudit @engComponent(name: CHEMISTRY) {
    molecules(ids: $moleculeIds) {
      ... on MoleculeNode {
        id
        currentVersion {
          id
          chemicalStructure {
            id
            molecularWeight {
              ... on MolecularWeightNode {
                value
              }
            }
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const GET_MOLECULAR_FORMULA_QUERY = gql`
  query GetMolecularFormulaQuery($moleculeIds: [StrictString!]!) @skipAudit @engComponent(name: CHEMISTRY) {
    molecules(ids: $moleculeIds) {
      ... on MoleculeNode {
        id
        currentVersion {
          id
          chemicalStructure {
            id
            chemicalFormula {
              ... on ChemicalFormulaNode {
                value
              }
            }
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const GET_IUPAC_NAME_QUERY = gql`
  query GetIupacNameQuery($moleculeIds: [StrictString!]!) @skipAudit @engComponent(name: CHEMISTRY) {
    molecules(ids: $moleculeIds) {
      ... on MoleculeNode {
        id
        currentVersion {
          id
          chemicalStructure {
            id
            iupacName {
              ... on IupacNameNode {
                value
              }
            }
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const GET_CAS_REGISTRY_NUMBER_QUERY = gql`
  query GetCasRegistryNumberQuery($moleculeIds: [StrictString!]!) @skipAudit @engComponent(name: CHEMISTRY) {
    molecules(ids: $moleculeIds) {
      ... on MoleculeNode {
        id
        currentVersion {
          id
          chemicalStructure {
            id
            casRegistryNumber {
              ... on CasRegistryNumberNode {
                value
              }
            }
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
